import {
  ColorScheme,
  COOKIE_NAME,
  LOADER_UI_PREFERENCES_ID,
} from '@inway/meteor-layout-helper';

/**
 * Sets the color scheme preference for the UI.
 *
 * This function updates the color scheme preference by modifying the dataset of the loader UI preferences element.
 *
 * @param scheme - The color scheme to set. Can be one of:
 *   - 'auto': Automatically determine the color scheme based on system preferences
 *   - 'light': Use light color scheme
 *   - 'dark': Use dark color scheme
 *
 * @example
 * // Set color scheme to dark mode
 * setPreferredColorScheme('dark');
 *
 * @example
 * // Set color scheme to automatically follow system preferences
 * setPreferredColorScheme('auto');
 */
export default function setPreferredColorScheme(
  scheme: ColorScheme,
  domain: string
): void {
  const loaderUiPreferences =
    typeof document !== 'undefined'
      ? document.getElementById(LOADER_UI_PREFERENCES_ID)
      : null;
  if (loaderUiPreferences) {
    loaderUiPreferences.dataset.colorScheme = scheme;
  }

  try {
    if (scheme === 'auto') {
      cookieStore.delete(COOKIE_NAME);
    } else {
      cookieStore.set({
        name: COOKIE_NAME,
        value: `v1:${scheme}`,
        sameSite: 'strict',
        domain,
      });
    }
  } catch (error) {
    console.error('Failed to set color scheme cookie:', error);
  }
}
